import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/live-streaming/',
    name: 'Live Streaming Trackvision',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'b3h-new-trackvision-menu:read',
            'b3j-trackvision-live-streaming:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/trackvideo-2/'),
  },
  {
    path: '/video-history/',
    name: 'Video History Trackvision',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'b3h-new-trackvision-menu:read',
            'b3k-trackvision-video-history:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/videohistory-3/indexV2'),
  },
  {
    path: '/video-history/download',
    name: 'Video History Trackvision Download',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b3h-new-trackvision-menu:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/videohistory-3/download'),
  },
  {
    path: '/vehicle-media',
    name: 'Vehicle Media',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'b3i-menu-media:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/media/'),
  },
]
